import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

export const userDashboardRouteGroup = new AppRouteGroup({
  path: '/dashboard',
});

export const userDashboardSavedItemsRoute = userDashboardRouteGroup.route({
  path: 'saved-items',
  searchParams: ['tab', 'page'],
});

export const userDashboardViewEmploymentOnboardingRoute =
  userDashboardRouteGroup.route({
    path: 'employment-profile/:slug',
    params: ['slug'],
  });

export const userDashboardViewEmploymentRoute = userDashboardRouteGroup.route({
  path: 'employment-profile',
});

export const userDashboardAccountSettingsRoute = userDashboardRouteGroup.route({
  path: 'account-settings',
});

export const userDashboardPaymentMethodsAddCardRoute =
  userDashboardRouteGroup.route({
    path: 'payment-methods/add-card',
  });

export const userDashboardApplicationHistoryRoute =
  userDashboardRouteGroup.route({
    path: 'application-history',
  });
